import React, { useState, useEffect } from "react";

import MenuItem from "@mui/material/MenuItem";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button, ListItemText, MenuList, Paper, Select, TextField } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import PersonIcon from "@mui/icons-material/Person";
import MenuIcon from "@mui/icons-material/Menu";
import FaceIcon from "@mui/icons-material/Face";
import CheckIcon from "@mui/icons-material/Check";
import { useSelector } from "react-redux";
import api from "../../../../../API";

const VieAsgPage = (props:any) => {

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;
  
  var nav = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const [backdrop, setBackdrop] = useState<boolean>(false)


  const [task, setTask] = useState("")

  const [worker, setWorker] = useState("")

  const [category, setCategory] = useState("")

  const [asg_cnt, setAsg_cnt] = useState(0)

  const [vieWorkers, setVieWorkers] = useState<any[]>([])


  const getViePrcWorkerList = async () => {
    setBackdrop(true)
    var result = await api.get("/vieWorkerList", {
      // params: {email:email,page:page,instruction_yn:instruction_yn}
      params: {email:email,role:'VIE_PRC'}
    });
    // console.log("result.data", result.data);
    let swWorkList:any[] = []
    var datas = result.data.datas.map((worker:any) => {
      // // console.log(worker.name, worker.roles[0].user_id)
      swWorkList.push({"name":worker.name,"user_id": worker.roles[0].user_id})
    })

    // console.log('swWorkList',swWorkList)
    setVieWorkers(swWorkList)
    setBackdrop(false)
  }

  const vieAsgByTaskAndCnt = async () => {

    const formData = new FormData();

    if(worker == ""){
      alert('워커 를 선택하세요.')
      return;
    }

    if(task == ""){
      alert('TASK 를 선택하세요.')
      return;
    }

    if(category == ""){
      alert('CATEGORY 를 선택하세요.')
      return;
    }

    if(asg_cnt == 0){
      alert('할당건수 를 입력하세요.')
      return;
    }

    formData.append("email", email);

    formData.append("worker", worker);

    formData.append("task", task);

    formData.append("category", category);

    formData.append("asg_cnt", asg_cnt.toString());

    console.log(email, worker, task ,category, asg_cnt)
    // return ;
    await api.post("/vie-task-assignment",formData)
    .then((res:any) => { alert("작업할당 완료"); })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})

  }

  useEffect(()=> {
    getViePrcWorkerList()
  },[])

  return (
    <Paper sx={{padding:"16px"}}>
      <Box sx={{fontSize:"32px"}}>Vie - task 할당 페이지</Box>
      <Box sx={{margin:"16px"}}>

        <Box display="flex" sx={{margin:"8px",marginTop:"16px",alignItems: "center"}}>
          <Box sx={{fontSize:"20px",fontWeight:700, width:"130px"}}>워커</Box>
          <Select id="order" value={worker || ""} onChange={(e)=> {setWorker(e.target.value);}} sx={{width:"300px",height: "40px", marginLeft: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={""}>선택하세요.</MenuItem>
            {vieWorkers.length > 0 && vieWorkers.map((worker:any, index:any) => 
              <MenuItem key={worker+index} dense value={worker.user_id}>{worker.name} - ({worker.user_id})</MenuItem>
            )}
          </Select>
        </Box>

        <Box display="flex" sx={{margin:"8px",marginTop:"16px",alignItems: "center"}}>
          <Box sx={{fontSize:"20px",fontWeight:700, width:"130px"}}>Task 선택</Box>
          <Select id="task" value={task || ""} onChange={(e) => {setTask(e.target.value);}} sx={{color:"blue",width:"300px", height: "40px", marginLeft: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
            <MenuItem dense value={""}>선택하세요.</MenuItem>
            <MenuItem dense value={"01"}>01. CSQA</MenuItem>
            {/* <MenuItem dense value={"02"}>02. Hellaswag</MenuItem> */}
            {/* <MenuItem dense value={"03"}>03. MMLU</MenuItem> */}
            <MenuItem dense value={"04"}>04. TruthfulQA</MenuItem>
            <MenuItem dense value={"05"}>05. Common-Gen</MenuItem>
            <MenuItem dense value={"06"}>06. HHH</MenuItem>
            <MenuItem dense value={"07"}>07. Winogrande</MenuItem>
            {/* <MenuItem dense value={"08"}>08. Drop</MenuItem> */}
            <MenuItem dense value={"09"}>09. BoolQ</MenuItem>
            {/* <MenuItem dense value={"10"}>10. MMMU</MenuItem> */}
          </Select>
        </Box>

        <Box display="flex" sx={{margin:"8px",marginTop:"16px",alignItems: "center"}}>
          <Box sx={{fontSize:"20px",fontWeight:700, width:"130px"}}>CATEGORY</Box>
          <Select id="category" value={category || ""} onChange={(e) => {setCategory(e.target.value);}} sx={{color:"blue",width:"300px", height: "40px", marginLeft: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
            <MenuItem dense value={""}>선택하세요.</MenuItem>
            <MenuItem dense value={"사회/정치/산업"}>사회/정치/산업</MenuItem>
            <MenuItem dense value={"건강/의학"}>건강/의학</MenuItem>
            <MenuItem dense value={"날씨/자연/동식물"}>날씨/자연/동식물</MenuItem>
            <MenuItem dense value={"음식/일상생활"}>음식/일상생활</MenuItem>
            <MenuItem dense value={"IT/과학"}>IT/과학</MenuItem>
            <MenuItem dense value={"역사/문화/예술/공예/의상"}>역사/문화/예술/공예/의상</MenuItem>
            <MenuItem dense value={"일반상식/기타"}>일반상식/기타</MenuItem>
          </Select>
        </Box>

        <Box display="flex" sx={{margin:"8px",marginTop:"16px",alignItems: "center"}}>
          <Box sx={{fontSize:"20px",fontWeight:700, width:"130px"}}>할당건수</Box>
          <TextField
            id="asg_cnt"
            value={asg_cnt}
            type="number"
            variant="standard"
            sx={{width:"280px", height:"40px", marginLeft:"16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
            InputProps={{
              style: {width: "280px", height:"40px", fontSize:"20px"},
            }}
            onChange={(e) => {setAsg_cnt(Number(e.target.value));}}
          />
        </Box>

        <Box display="flex" sx={{margin:"130px",marginTop:"16px",alignItems: "center"}}>
          <Button variant="contained" color="secondary" sx={{fontSize:"20px",fontWeight:700, margin:"16px 24px"}}
            onClick={() => {
              vieAsgByTaskAndCnt();
            }}
          >
            할당하기
          </Button>
        </Box>

      </Box>
    </Paper>
  );
};

export default VieAsgPage;
